export default __webpack_public_path__ + "static/media/achievement_achieved.49d0cc2e.png";